<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchInspPrerequisiteForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchInspPrerequisiteForm from '@/components/organisms/terminal/form/SearchInspPrerequisiteForm.vue'

export default {
  name: 'SearchInspPrerequisite',

  components: {
    SearchInspPrerequisiteForm,
  },
}
</script>
